import { Injectable } from '@angular/core';
import { DatasourceService } from './datasource.service';

@Injectable({
	providedIn: 'root'
})
export class ProviderInstanceResourcesDatasourceUrlService {

private route: string = "provider-instance-resources";

	constructor(private datasource: DatasourceService) {
		console.log("Init ProviderInstanceResourcesDatasourceUrlService");
	}

	public PhotoUrl(providerId: string, providerTypeId: string, providerInstanceId: string, providerInstanceResourceId: string, includeProviderImage: boolean, defaultImageifNotFound: boolean): string {
        let partialUrl = `${this.route}/${providerId}/${providerTypeId}/${providerInstanceId}/${providerInstanceResourceId}/photo?includeProviderImage=${includeProviderImage}&defaultImageifNotFound=${defaultImageifNotFound}`;

        return this.datasource.getUrl(partialUrl);
	}
}
